import axios from 'axios'
import { SelectOptionString } from '../../../common/filter/models'
import { PAYMENT_TICKET_CLOSE_REASON_LOOKUP_URL } from './consts'

export interface ICloseReasonLookupResponse {
  success: boolean
  data: SelectOptionString[] | null
  totalRows?: number
}

/**
 * Словарь причин закрытия депозита. Источник — enum бэкенда, поэтому список в фильтре не может
 * отстать от того, что реально проставляется на заявки.
 */
export const getCloseReasons = () =>
  axios.get<ICloseReasonLookupResponse>(PAYMENT_TICKET_CLOSE_REASON_LOOKUP_URL)
